import * as React from "react";
import { ThemeProvider } from "@material-ui/styles";
import { boxShadow, colors, fontFamilyPrimary } from "swyft-react-core";
import createTheme from "@material-ui/core/styles/createTheme";
import { responsiveFontSizes } from "@material-ui/core";

colors.alternate = "#F5FAFD";

let innerTheme = createTheme({
  palette: {
    primary: {
      main: colors.darkGrey
    },
    secondary: {
      main: colors.secondary,
      contrastText: colors.white
    },
    background: {
      default: colors.white
    },
    text: {
      primary: colors.darkGrey
    }
  },
  typography: {
    fontFamily: fontFamilyPrimary,
    h1: {
      fontWeight: 300,
      letterSpacing: "-1.5px",
      lineHeight: 1.145,
      fontSize: "6rem" //96px
    },
    h2: {
      fontWeight: 300,
      letterSpacing: "-0.5px",
      lineHeight: 1.366,
      fontSize: "3.75rem" //60px //h5
    },
    h3: {
      letterSpacing: 0,
      lineHeight: 1.25,
      fontSize: "3rem" //48px
    },
    h4: {
      letterSpacing: 0.25,
      lineHeight: 1.345,
      fontSize: "2.125rem" //34px //h1
    },
    h5: {
      letterSpacing: 0,
      lineHeight: 1.416,
      fontSize: "1.5rem" //24px //h6
    },
    h6: {
      letterSpacing: "0.15px",
      lineHeight: 1.555,
      fontSize: "1.125rem" //18px //h2 //h3 //button //body1 //subtitle1
    },
    subtitle1: {
      letterSpacing: "0.15px",
      lineHeight: 1.5,
      fontSize: "1rem" //16px //body2 //subtitle2
    },
    subtitle2: {
      letterSpacing: "0.1px",
      lineHeight: 1.5,
      fontSize: "1rem" //16px
    },
    body1: {
      letterSpacing: "0.5px",
      lineHeight: 1.75,
      fontSize: "1rem" //16px //h4
    },
    body2: {
      letterSpacing: "0.25px",
      lineHeight: 1.43,
      fontSize: "0.875rem" //14px
    },
    button: {
      fontWeight: 600,
      letterSpacing: "1.25px",
      lineHeight: 1.25,
      fontSize: "0.875rem" //16px
    },
    caption: {
      letterSpacing: "0.4px",
      lineHeight: 1.33,
      fontSize: "0.75rem" //12px //caption //overline
    },
    overline: {
      letterSpacing: "1.5px",
      lineHeight: 1.6,
      fontSize: "0.625rem", //10px
      textTransform: "uppercase"
    }
  },
  overrides: {
    MuiButton: {
      root: {
        fontWeight: "bold",
        textTransform: "none",
        padding: "12px"
      },
      outlined: {
        "fontWeight": "normal",
        "boxShadow": boxShadow,
        "background": colors.white,
        "&:hover": {
          backgroundColor: colors.lightSecondary
        },
        "padding": "12px"
      },
      outlinedSecondary: {
        "&:hover": {
          backgroundColor: colors.lightSecondary
        }
      },
      contained: {
        fontWeight: "normal"
      }
    },
    MuiSvgIcon: {
      root: {
        "& .Swyft-icon, &.Swyft-icon": {
          stroke: colors.primary,
          fill: colors.primary
        },
        "verticalAlign": "top",
        "marginRight": "8px"
      },
      colorPrimary: {
        "& .Swyft-icon, &.Swyft-icon": {
          stroke: colors.primary,
          fill: colors.primary
        }
      },
      colorSecondary: {
        "& .Swyft-icon, &.Swyft-icon": {
          stroke: colors.secondary,
          fill: colors.secondary
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
});

innerTheme = responsiveFontSizes(innerTheme);
const OverrideTheme = (props: { children?: React.ReactNode }) => (
  <ThemeProvider theme={innerTheme}>{props.children}</ThemeProvider>
);

export default OverrideTheme;
